import type { StudentSummaryVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveStudentSummary = createApiThunk<StudentSummaryVM, string | undefined>(
  "students/retrieveStudentSummary",
  async (studentId: string | undefined, { extra: { studentRepository, adminRepository } }) => {
    if (studentId) return adminRepository!.getStudentSummary(studentId);
    return studentRepository!.summary();
  },
);
